import React, { useState } from "react";
import { FilterDropdown, DateRangePicker } from "@components/library/UI";

import "./LatestRecordsTab.sass";

// --- MOCK DATA (With timestamps for filtering!) ---
const mockRecords = [
  {
    id: 1,
    timestamp: "2026-01-23T05:19:37",
    date: "Jan 23 at 05:19:37",
    type: "Buy",
    action: "Open short of",
    pair: "ETH/USDT 3x",
    price: "$4,945.0",
    total: "$49,450.37",
  },
  {
    id: 2,
    timestamp: "2026-01-22T02:34:07",
    date: "Jan 22 at 02:34:07",
    type: "Buy",
    action: "Open short of",
    pair: "ETH/USDT 10x",
    price: "$88,545.0",
    total: "$45,450.37",
  },
  {
    id: 3,
    timestamp: "2026-01-21T19:09:37",
    date: "Jan 21 at 19:09:37",
    type: "Sell",
    action: "Open short of",
    pair: "ETH/USDT 10x",
    price: "$87,545.0",
    total: "$122,450.37",
  },
  {
    id: 4,
    timestamp: "2025-12-20T07:42:57",
    date: "Dec 20 at 07:42:57",
    type: "Buy",
    action: "Open short of",
    pair: "ETH/USDT 10x",
    price: "$91,345.0",
    total: "$234,450.37",
  },
  {
    id: 5,
    timestamp: "2025-11-15T07:57:13",
    date: "Nov 15 at 07:57:13",
    type: "Buy",
    action: "Open short of",
    pair: "ETH/USDT 10x",
    price: "$89,567.0",
    total: "$49,450.37",
  },
];

export const LatestRecordsTab = () => {
  const [instrument, setInstrument] = useState("All Instruments");

  // 1. State for the dates
  const [dateRange, setDateRange] = useState({ from: null, to: null });

  // 2. The Filter!
  const filteredRecords = mockRecords.filter((record) => {
    // If no complete date range is picked, show everything
    if (!dateRange.from || !dateRange.to) return true;

    const recordDate = new Date(record.timestamp);

    // Set the end date to 23:59:59 so it includes the whole last day
    const endOfDay = new Date(dateRange.to);
    endOfDay.setHours(23, 59, 59, 999);

    return recordDate >= dateRange.from && recordDate <= endOfDay;
  });

  return (
    <div className="latest-records">
      <div className="latest-records__filters">
        {/* Pass the range perfectly into our state */}
        <DateRangePicker onConfirm={(range) => setDateRange(range)} />

        <FilterDropdown
          hasSearch={true}
          className="latest-records__dropdown"
          value={instrument}
          options={["All Instruments", "Crypto", "Fiat"]}
          onChange={setInstrument}
        />
      </div>

      <div className="latest-records__timeline">
        {filteredRecords.length > 0 ? (
          filteredRecords.map((record, index) => {
            const isBuy = record.type === "Buy";
            const isLastItem = index === filteredRecords.length - 1;

            return (
              <div className="latest-records__item" key={record.id}>
                <div className="latest-records__time">{record.date}</div>
                <div className="latest-records__divider">
                  <div className="latest-records__dot"></div>
                  {!isLastItem && <div className="latest-records__line"></div>}
                </div>
                <div className="latest-records__content">
                  <span
                    className={`latest-records__badge ${
                      isBuy
                        ? "latest-records__badge--buy"
                        : "latest-records__badge--sell"
                    }`}
                  >
                    {record.type}
                  </span>
                  <p className="latest-records__text">
                    {record.action}{" "}
                    <span className="latest-records__text--highlight">
                      {record.pair}
                    </span>{" "}
                    at a price of{" "}
                    <span className="latest-records__text--highlight">
                      {record.price}
                    </span>{" "}
                    for a total of{" "}
                    <span className="latest-records__text--highlight">
                      {record.total}
                    </span>
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ color: "#888", padding: "2rem" }}>
            No records found for this date range.
          </p>
        )}
      </div>
    </div>
  );
};
